<template>
    <div>
        <HeaderControls :myWeek='false' @filterUpdated='filterUpdate' @collapseToggleUpdated='collapseToggleUpdate' />
        <div class="container-fluid">
            <DeliverableList :filterQuery="filterQuery" :myWeek="false" :expandAll="expandAll" @collapseToggleUpdated='collapseToggleUpdate' />
        </div>
    </div>
</template>
<script>
import DeliverableList from "../components/deliverables/List";
import HeaderControls from "../components/common/HeaderControls";
import { mapGetters } from "vuex";

export default {
    data() {
    return {
      filterQuery: {
        query: "",
        filterByDate: false,
        filterByDateCreated: false,
        filterByDateCompleted: false,
        dateRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCreatedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        dateCompletedRange: {
          startDate: new Date(),
          endDate: new Date()
        },
        status: [],
        outlet: [],
        deliverableType: [],
        tag: [],
        department: [],
        coordinator: [],
        project: [],
      },
      expandAll: !this.isMobile()
    }
  },
  computed: {
    ...mapGetters(["allCustomFields", 'allUsers']),
    forceUpdateCounter() {
      return this.$store.state.deliverables.forceUpdateCounter
    },
    statuses() {
      let statusField = _.find(this.allCustomFields, { field_key: "status" });
      if (typeof statusField != "undefined") {
        let valueSet = [],
          data = JSON.parse(statusField.value_set);
        Object.keys(data).forEach(function(item) {
          valueSet.push(data[item]);
        });
        return valueSet;
      }
    }
  },
  components: {
    DeliverableList,
    HeaderControls
  },
  methods: {
    filterUpdate(filterQuery) {
      this.filterQuery = filterQuery
    },
    collapseToggleUpdate(expandAll) {
      this.expandAll = expandAll
    }
  }
}
</script>
